import React from "react";

class TermsBanner extends React.Component {
  render() {
    return (
      <div id="terms-hero" className="main-banner item-bg-one">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="main-banner-text">
                    <h4>Legal</h4>
                    <h1>
                      Terms <span>&amp;</span> Conditions
                    </h1>
                    <p>Our service terms, policies, and usage guidelines.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TermsBanner;
